<template>
  <div class="product-page">
    <div class="d-flex align-center justify-space-between">
      <h1 class="my-0">Bundles</h1>
      <v-btn color="primary" @click="$router.push({ name: 'website.apps.bundle.create' })">
        <v-icon left>mdi-plus</v-icon>Create offer
      </v-btn>
    </div>
    <p>
      Offer customers to buy in a bulk of products with your attractive discount.
    </p>
    <Offer />
  </div>
</template>

<script>
import Offer from './components/Offer';
export default {
  components: {
    Offer,
  },
};
</script>
